import type { BaseTranslation } from '../i18n-types';

const en = {
    // General
    appTitle: 'Intranet',
    welcome: 'Welcome at {title:string}!',
    loading: 'Loading ...',
    error: 'An error occurred',

    language: 'Language',
    languages: {
        en: 'English',
        de: 'Deutsch',
    },

    // Appearance
    appearance: 'Appearance',
    themeLight: 'Light',
    themeDark: 'Dark',
    themeSystem: 'System',
    switchAppearance: 'Appearance: {mode:string}. Click to change.',

    // Navigation
    home: 'Home',
    admin: 'Admin',
    logout: 'Logout',

    // User Info
    userInfo: 'User Information',
    email: 'Email',
    displayName: 'Display Name',
    firstName: 'First Name',
    lastName: 'Last Name',
    groups: 'Groups',

    // App Cards
    applications: 'Applications',
    noAppsAvailable: 'No applications available for your groups.',
    openApp: 'Open {application:string}',
    public: 'Public',
    visibility: 'Visibility',

    // Search & favourites
    searchApps: 'Search applications',
    clearSearch: 'Clear search',
    noSearchResults: 'No applications match "{query:string}".',
    favorites: 'Favorites',
    otherApplications: 'All applications',
    addFavorite: 'Add to favorites',
    removeFavorite: 'Remove from favorites',

    // Admin Section
    adminPanel: 'Admin Panel',
    manageApps: 'Manage Applications',
    addApp: 'Add Application',
    editApp: 'Edit Application',
    deleteApp: 'Delete Application',
    appTitle_field: 'Title',
    appDescription: 'Description',
    appImage: 'Image URL',
    appLink: 'Link',
    appGroups: 'Access Groups',
    appActive: 'Active',
    appSortOrder: 'Sort Order',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    confirmDelete: 'Are you sure you want to delete this application?',

    // Messages
    saveSuccess: 'Saved successfully',
    deleteSuccess: 'Deleted successfully',
    saveFailed: 'Failed to save',
    deleteFailed: 'Failed to delete',
    accessDenied: 'Access denied. Admin privileges required.',

    // Login
    loginRequired: 'Please login to continue',
    loginWithOIDC: 'Login with OIDC',
    loggingIn: 'Logging in...',
    loginFailed: 'Sign-in failed. Please try again.',
    redirectingIn: 'Redirecting in {countdown:number} second{{s}} ...',

    // Session / OIDC
    refreshSession: 'Refresh session',
    refreshingSession: 'Refreshing session…',
    refreshGroupAssignments: 'Refresh group assignments',
    reloginToRefreshClaims: 'Re-login to refresh permissions',
    reloggingIn: 'Redirecting to login…',

    // AdminPage specific translations
    everyone: 'Everyone',
    internal: 'Internal',
    active: 'Active',
    inactive: 'Inactive',
    actions: 'Actions',
    tableHeaders: {
        title: 'Title',
        link: 'Link',
        groups: 'Groups',
        visibility: 'Visibility',
        active: 'Active',
        actions: 'Actions',
    },
    noAppsCreated: 'No applications created yet.',
    dropImage: 'Drop image here or click to upload',
    supportsImage: 'Supports JPG, PNG (max 5MB)',
    orEnterImageUrl: 'Or enter an image URL:',
    enterGroupName: 'Enter group name',
    add: 'Add',
    leaveEmptyForEveryone: 'Leave empty for everyone',
    preview: 'Preview',
    imageUrlPlaceholder: 'https://example.com/image.jpg',
    linkPlaceholder: 'https://example.com',
} satisfies BaseTranslation;

export default en;
